import { useState } from "react";
import { API } from "../data/siteData";
import { csrfHeaders } from "../utils/csrf";

function formatError(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || "Invalid input.").join(" ");
  return "Your password could not be updated. Please try again.";
}

function validatePasswordConfirmation(newPassword, confirmPassword) {
  return newPassword === confirmPassword ? "" : "New password and confirmation must match.";
}

export default function usePasswordChange() {
  const [values, setValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [state, setState] = useState("idle");

  const changeValue = (field, value) => setValues((currentValues) => ({
    ...currentValues,
    [field]: value,
  }));

  const updatePassword = async (event) => {
    event.preventDefault();
    setError("");
    const confirmationError = validatePasswordConfirmation(values.newPassword, values.confirmPassword);
    if (confirmationError) {
      setError(confirmationError);
      return;
    }
    setState("loading");
    try {
      const response = await fetch(`${API}/auth/admin-change-password`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json", ...csrfHeaders() },
        body: JSON.stringify({
          current_password: values.currentPassword,
          new_password: values.newPassword,
        }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(formatError(body.detail));
      setValues({ currentPassword: "", newPassword: "", confirmPassword: "" });
      setState("success");
    } catch (updateError) {
      setError(updateError.message);
      setState("idle");
    }
  };

  return { changeValue, error, state, updatePassword, values };
}